import { useState } from 'react'
import { Box } from '@mui/material'
import { Map, Storefront, CardGiftcard } from '@mui/icons-material'
import { PageShell } from '@components/common/PageShell'
import { ResponsiveTabs, type ResponsiveTabItem } from '@components/common/ResponsiveTabs'
import LocationActivityPage from './LocationActivityPage'
import { BusinessesTab } from '../components/BusinessesTab'
import { RewardsTab } from '../components/RewardsTab'

type MarketingTab = 'activity' | 'businesses' | 'rewards'

const TABS: ResponsiveTabItem[] = [
  { key: 'activity', label: 'Location Activity', icon: <Map /> },
  { key: 'businesses', label: 'Businesses', icon: <Storefront /> },
  { key: 'rewards', label: 'Rewards', icon: <CardGiftcard /> },
]

export default function MarketingPage() {
  const [tab, setTab] = useState<MarketingTab>('activity')

  return (
    <PageShell title="Marketing">
      <ResponsiveTabs tabs={TABS} value={tab} onChange={(k) => setTab(k as MarketingTab)} />

      {/* Only the active tab is mounted, so each tab's queries fire on first open. */}
      <Box role="tabpanel" sx={{ pt: 2, minWidth: 0 }}>
        {tab === 'activity' && <LocationActivityPage />}
        {tab === 'businesses' && <BusinessesTab />}
        {tab === 'rewards' && <RewardsTab />}
      </Box>
    </PageShell>
  )
}
